/**
 * Integrations List - Page script
 *
 * Uses Pagination and Search modules for AJAX search and load more functionality
 */

import { Pagination } from '../utils/searchPagination/Pagination';
import { Search } from '../utils/searchPagination/Search';

interface IntegrationsListConfig {
    readonly baseUrl: string;
    readonly loadingText: string;
    readonly loadMoreText: string;
}

/**
 * Initializes the integrations page logic including mobile toggles and AJAX search.
 */
function initIntegrationsList(config: IntegrationsListConfig): void {
    // 1. Mobile Category Toggle
    document.querySelectorAll('.toggle-categories').forEach((btn) => {
        btn.addEventListener('click', () => {
            const categories = document.querySelector('.categories');

            if (categories) {
                categories.classList.toggle('show');
            }
        });
    });

    // 2. Search and Pagination Setup
    const collectParams = (page: number): URLSearchParams => {
        const params = new URLSearchParams();
        const searchValue = search.getValue();

        if (searchValue.length > 0) {
            params.append('search', searchValue);
        }

        if (page > 1) {
            params.set('page', String(page));
        }

        return params;
    };

    const buildUrl = (page: number = 1): string => {
        const params = collectParams(page);
        const queryString = params.toString();

        return queryString ? `${config.baseUrl}?${queryString}` : config.baseUrl;
    };

    const triggerSearch = (): void => {
        pagination.resetPage();
        void pagination.loadPage(buildUrl());
    };

    const search = new Search({
        inputSelector: '#search-page-query',
        clearSelector: '.clear-search',
        debounceMs: 500,
        onSearch: triggerSearch
    });

    const pagination = new Pagination({
        containerSelector: '.integrations-list',
        resultsSelector: '.integrations-list',
        baseUrl: config.baseUrl,
        mode: 'loadMore',
        loadMoreSelector: '#load-more',
        itemCountSelector: '#item-count',
        updateHistory: true,
        loadingText: config.loadingText,
        loadMoreText: config.loadMoreText,
        getParams: collectParams,
        onAfterLoad: () => {
            search.hideSearching();
        }
    });
}

/**
 * Entry point: Parses configuration from the DOM and starts initialization.
 */
document.addEventListener('DOMContentLoaded', () => {
    const configElement = document.querySelector<HTMLElement>('[data-integrations-config]');

    if (configElement && configElement.dataset.integrationsConfig) {
        try {
            const config = JSON.parse(configElement.dataset.integrationsConfig) as IntegrationsListConfig;
            initIntegrationsList(config);
        } catch (error) {
            console.error('IntegrationsList: Invalid config JSON', error);
        }
    }
});

export { initIntegrationsList };
